var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FF9D59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9585 46.2812C38.146 46.9062 39.271 47.2188 40.3335 47.2188C41.396 47.2188 42.5054 46.9062 43.6616 46.2812C44.8491 45.6562 45.7397 44.8906 46.3335 43.9844C46.3022 43.1094 45.5991 42.375 44.2241 41.7812C42.8491 41.1875 41.5522 40.8906 40.3335 40.8906C39.1147 40.8906 37.8179 41.1875 36.4429 41.7812C35.0679 42.3438 34.3647 43.0781 34.3335 43.9844C34.9272 44.8906 35.8022 45.6562 36.9585 46.2812ZM42.4429 33.9062C41.8491 33.3125 41.146 33.0156 40.3335 33.0156C39.521 33.0156 38.8179 33.3125 38.2241 33.9062C37.6304 34.5 37.3335 35.2031 37.3335 36.0156C37.3335 36.8281 37.6304 37.5312 38.2241 38.125C38.8179 38.7188 39.521 39.0156 40.3335 39.0156C41.146 39.0156 41.8491 38.7188 42.4429 38.125C43.0366 37.5312 43.3335 36.8281 43.3335 36.0156C43.3335 35.2031 43.0366 34.5 42.4429 33.9062ZM33.2554 32.9688C35.2241 31 37.5835 30.0156 40.3335 30.0156C43.0835 30.0156 45.4272 31 47.3647 32.9688C49.3335 34.9062 50.3179 37.25 50.3179 40C50.3179 42.75 49.3335 45.1094 47.3647 47.0781C45.4272 49.0156 43.0835 49.9844 40.3335 49.9844C37.5835 49.9844 35.2241 49.0156 33.2554 47.0781C31.3179 45.1094 30.3491 42.75 30.3491 40C30.3491 37.25 31.3179 34.9062 33.2554 32.9688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfolio);
export default __webpack_public_path__ + "static/media/iconPortfolio.a0a5911248da56186d5d9a6e08133360.svg";
export { ForwardRef as ReactComponent };